import {
  isExceptionExist,
  SopElementResponse,
  ExceptionsEnum,
  isSopExpired,
  DeliveryType,
} from '@commerce-cart-webcomponents/sdk';
import { AlertMessage, Theme, useTranslation } from '@nextgen-web-framework/all';
import { ProductFlag } from '../../product-flag/ProductFlag';

export type SopItemErrorMsgsProps = {
  sopElement: SopElementResponse;
  onSOPRemoveClickHandler: (sopId: string, entryIds: number[]) => void;
  isSopOOS?: boolean;
  classname?: string;
};

const SopItemErrorMsgs = ({ sopElement, onSOPRemoveClickHandler, isSopOOS, classname }: SopItemErrorMsgsProps) => {
  const t = useTranslation();
  const showlineItemError = (sopElement: SopElementResponse, errorText: string) => (
    <div className={classname}>
      <AlertMessage
        theme={Theme.ERROR}
        icon={'exclamation-square'}
        content={{
          heading: errorText,
        }}
        textLink={{
          text: t('cart.cartLineItemErrorMsgs.remove'),
          onClick: () => onSOPRemoveClickHandler(sopElement.sopId || '', sopElement.entryIds || []),
        }}
      />
    </div>
  );

  return (
    <>
      {isSopOOS && showlineItemError(sopElement, t('cart.cartLineItems.OOS'))}
      {isSopExpired(true, {}, sopElement) &&
        showlineItemError(sopElement, t('cart.cartlineItemHeader.subscriptionExpired'))}
      {isExceptionExist(DeliveryType.Bopis, sopElement.errors ?? []) &&
        showlineItemError(sopElement, t('cart.cartLineItemsHeader.noPickUp'))}
      {isExceptionExist(DeliveryType.Homedelivery, sopElement.errors ?? []) &&
        showlineItemError(sopElement, t('cart.cartLineItemsHeader.noHomedelivery'))}
      {(isExceptionExist(DeliveryType.Kerry, sopElement.errors ?? []) ||
        isExceptionExist(DeliveryType.Seveneleven, sopElement.errors ?? [])) &&
        showlineItemError(sopElement, t('cart.cartLineItemsHeader.no3rdPartyPickup'))}
      {isExceptionExist(ExceptionsEnum.Exceptions.Restricted, sopElement.errors ?? []) &&
        showlineItemError(sopElement, t('cart.errorMessages.currentlyUnavailble'))}
      {isExceptionExist(ExceptionsEnum.Exceptions.CartLevelPromotion, sopElement.errors ?? []) && (
        <ProductFlag iconName="tags" text={t('cart.errorMessages.cartPromotions')} theme={Theme.GRAY} />
      )}
    </>
  );
};

export { SopItemErrorMsgs };
